export const windowSize = {
  width: $(window).width(),
}

$(function () {})

$(window).on('resize', function () {
  windowSize.width = $(this).width()
})

$( window ).on( 'load scroll resize', function updateTimeline() {
  for ( const timeline of document.querySelectorAll( '.timeline' ) ) {
    const timelineContainerHeight = timeline.querySelector( '.timeline-end-indicator' ).getBoundingClientRect().top - timeline.getBoundingClientRect().top;
    timeline.querySelector( '.timeline-container' ).style.height = `${timelineContainerHeight}px`;

    const viewportCenterY = window.innerHeight / 2;
    const timelinePointElement = timeline.querySelector( '.timeline-point' );
    for ( const eventElement of timeline.querySelectorAll( '.event' ) ) {
      const tagElement = eventElement.querySelector( '.event-tag' );
      eventElement.classList.toggle( 'event-passed', tagElement.getBoundingClientRect().top + timelinePointElement.getBoundingClientRect().height * 1.5 < viewportCenterY );
    }
  }
} );
